const catalog = {
  methods: {
    save_ (item) {
      if (this.$refs.SaveForm.validate()) {
        if (item.stock > 0 && this.newStock > 0) {
          this.stockDialog = true
        } else {
          this.$store.dispatch('saveData', { page: 2, data: item, item: this.id })
        }
      }
    },
    stock_ (selected, action = 0, stock = false) {
      if (this.$refs.StockForm.validate()) {
        this.$store.dispatch('saveData', { page: 2, data: { ...selected, stock_: (action > 0 && stock ? stock : false) }, item: selected.id })
        this.$emit('closed', true)
      }
    }
  }
}
export default catalog
